var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonenbezDaten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 66.8",
    style: {
      enableBackground: "new 0 0 64 66.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,37.6L41.5,37l1.4-0.9c5.5-3.7,8.8-9.8,8.8-16.4C51.7,8.8,42.9,0,32,0C21.2,0,12.3,8.8,12.3,19.7 c0,6.6,3.3,12.7,8.8,16.4l1.4,0.9L21,37.6C8.7,42.2,0.3,53.8,0,66.8h3.8C4.2,51.6,16.7,39.4,32,39.4s27.8,12.2,28.2,27.4H64 C63.7,53.8,55.3,42.2,43.1,37.6z M16.1,19.7c0-8.8,7.1-15.9,15.9-15.9s15.9,7.1,15.9,15.9S40.8,35.6,32,35.6S16.1,28.5,16.1,19.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonenbezDaten);
export default __webpack_public_path__ + "static/media/PersonenbezDaten.3b7208a70ba4967c1216ee2d2ea4ff60.svg";
export { ForwardRef as ReactComponent };